import React from 'react';
import './CTASection.css';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="cta-section-wrapper">
        <h2>Be a Part of Igbo-Eze North's Growth</h2>
        <p>Join hands with us in building a better and more prosperous community for all.</p>
        <div className="cta-section-buttons">
          <Link to="/contact" className="cta-section-btn cta-section-primary-btn">Contact Us</Link>
          <Link to="/create-feedback" className="cta-section-btn cta-section-secondary-btn">Give Feedback</Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;